export interface ArticlePreviewData {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  image: string;
  internal: boolean;
}

export interface ArticleContent {
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  image: string;
  readTime: string;
  sections: {
    heading?: string;
    paragraphs: string[];
    listItems?: { icon: string; text: string }[];
    table?: { headers: string[]; rows: string[][] };
    note?: string;
  }[];
}

export const articlePreviews: ArticlePreviewData[] = [
  {
    slug: 'basetao-spreadsheet-guide-2026',
    title: 'Ultimate Basetao Spreadsheet Guide 2026',
    excerpt: 'Everything you need to know about Basetao Spreadsheet — from setup and navigation to advanced tips for finding the best products and deals.',
    category: 'Guide',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20desk%20with%20laptop%20displaying%20colorful%20spreadsheet%20interface%2C%20warm%20natural%20morning%20lighting%2C%20soft%20cream%20and%20beige%20neutral%20tones%2C%20editorial%20productivity%20photography%2C%20organized%20desk%20with%20notebooks%20and%20plant%2C%20Scandinavian%20design%20influence%2C%20bright%20peaceful%20atmosphere&width=800&height=500&seq=art-prev-01&orientation=landscape',
    internal: true,
  },
  {
    slug: 'basetao-review-2026',
    title: 'Basetao Review 2026: Is Basetao Legit? Honest Analysis',
    excerpt: 'An honest, detailed review covering pros, cons, user experience, quality checks, and whether Basetao Spreadsheet is the right choice for your shopping needs.',
    category: 'Reviews',
    image: 'https://readdy.ai/api/search-image?query=Modern%20fashion%20accessories%20and%20sneakers%20arranged%20beautifully%20on%20a%20light%20wooden%20surface%20with%20magnifying%20glass%2C%20warm%20natural%20window%20light%2C%20cream%20background%2C%20editorial%20product%20review%20photography%2C%20minimal%20composition%2C%20professional%20aesthetic&width=800&height=500&seq=art-prev-02&orientation=landscape',
    internal: true,
  },
  {
    slug: 'basetao-shipping-cost-guide',
    title: 'Basetao Shipping Cost Guide 2026: Complete Price Breakdown',
    excerpt: 'Complete breakdown of shipping rates by weight and destination, plus expert tips for finding the most affordable shipping lines for your international orders.',
    category: 'Shipping',
    image: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20and%20packaging%20tape%20neatly%20arranged%20on%20a%20clean%20light%20surface%2C%20warm%20natural%20lighting%2C%20minimal%20ecommerce%20logistics%20photography%2C%20soft%20cream%20tones%2C%20organized%20composition%2C%20modern%20warehouse%20aesthetic%2C%20clean%20professional%20look&width=800&height=500&seq=art-prev-03&orientation=landscape',
    internal: true,
  },
  {
    slug: 'basetao-coupon-discount-code',
    title: 'Basetao Coupon & Discount Code Guide 2026: Save More',
    excerpt: 'Discover the latest Basetao coupons, promo codes, and discount strategies to maximize your savings on every purchase throughout the year.',
    category: 'Savings',
    image: 'https://readdy.ai/api/search-image?query=Golden%20discount%20tags%20and%20coupon%20cards%20scattered%20elegantly%20on%20a%20light%20cream%20surface%20with%20a%20shopping%20bag%2C%20warm%20ambient%20lighting%2C%20soft%20shadows%2C%20editorial%20savings%20photography%2C%20clean%20minimal%20composition%2C%20modern%20retail%20aesthetic&width=800&height=500&seq=art-prev-04&orientation=landscape',
    internal: true,
  },
  {
    slug: 'basetao-warehouse-guide',
    title: 'Basetao Warehouse Guide: How Storage, QC & Consolidation Work',
    excerpt: 'A complete walkthrough of the Basetao warehouse process including quality control inspections, storage timelines, and package consolidation strategies.',
    category: 'Warehouse',
    image: 'https://readdy.ai/api/search-image?query=Organized%20warehouse%20storage%20shelves%20with%20neatly%20arranged%20packages%20and%20boxes%2C%20warm%20industrial%20lighting%2C%20clean%20concrete%20floors%2C%20modern%20logistics%20facility%20photography%2C%20professional%20composition%2C%20bright%20orderly%20atmosphere&width=800&height=500&seq=art-prev-05&orientation=landscape',
    internal: true,
  },
  {
    slug: 'is-basetao-safe',
    title: 'Is Basetao Safe? Complete Safety & Trust Guide 2026',
    excerpt: 'Everything you need to verify before purchasing — seller checks, payment security, QC verification, and community trust signals explained in detail.',
    category: 'Safety',
    image: 'https://readdy.ai/api/search-image?query=Blue%20shield%20security%20icon%20concept%20with%20a%20laptop%20displaying%20secure%20checkout%20interface%20on%20a%20clean%20light%20desk%2C%20warm%20natural%20window%20light%2C%20cream%20background%2C%20modern%20cybersecurity%20photography%2C%20minimal%20professional%20composition&width=800&height=500&seq=art-prev-06&orientation=landscape',
    internal: true,
  },
  {
    slug: 'basetao-alternatives',
    title: 'Basetao Alternatives & Comparisons: Best Options in 2026',
    excerpt: 'Compare Basetao with Superbuy, CSSBuy, Sugargoo and other top platforms. Find which shopping agent best fits your needs and budget.',
    category: 'Comparisons',
    image: 'https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20layout%20concept%20with%20two%20smartphones%20displaying%20shopping%20interfaces%20on%20a%20light%20wooden%20desk%2C%20warm%20natural%20lighting%2C%20cream%20background%2C%20editorial%20tech%20comparison%20photography%2C%20minimal%20clean%20composition&width=800&height=500&seq=art-prev-07&orientation=landscape',
    internal: true,
  },
  {
    slug: 'basetao-qc-guide',
    title: 'Basetao QC Guide: Quality Control Photos & Inspection Explained',
    excerpt: 'Master the QC process — learn how to interpret inspection photos, spot common defects, request additional checks, and protect your purchases.',
    category: 'QC Guide',
    image: 'https://readdy.ai/api/search-image?query=Professional%20quality%20inspection%20scene%20with%20a%20magnifying%20glass%20over%20clothing%20fabric%20detail%20on%20a%20light%20surface%2C%20warm%20natural%20light%2C%20cream%20background%2C%20editorial%20QC%20photography%2C%20minimal%20clean%20composition%2C%20detail%20focused%20aesthetic&width=800&height=500&seq=art-prev-08&orientation=landscape',
    internal: true,
  },
  {
    slug: 'basetao-beginners',
    title: 'Basetao Spreadsheet for Beginners: Step-by-Step Tutorial',
    excerpt: 'New to Basetao Spreadsheet? This beginner-friendly tutorial walks you through registration, navigation, first order placement, and essential tips.',
    category: 'Beginners',
    image: 'https://readdy.ai/api/search-image?query=Friendly%20welcoming%20workspace%20scene%20with%20a%20clean%20notebook%20and%20pen%20next%20to%20a%20laptop%20on%20a%20light%20desk%2C%20warm%20morning%20sunlight%2C%20cream%20background%2C%20editorial%20beginner%20guide%20photography%2C%20minimal%20composition%2C%20inviting%20learning%20atmosphere&width=800&height=500&seq=art-prev-09&orientation=landscape',
    internal: true,
  },
  {
    slug: 'best-basetao-finds',
    title: 'Best Basetao Spreadsheet Finds 2026: Top Picks & Hidden Gems',
    excerpt: 'Curated collection of the best products discovered through Basetao Spreadsheet — top-rated sneakers, trending fashion, and amazing value finds.',
    category: 'Finds',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20trending%20fashion%20items%20including%20sneakers%20watch%20and%20sunglasses%20beautifully%20styled%20on%20a%20light%20surface%2C%20warm%20natural%20lighting%2C%20cream%20background%2C%20editorial%20product%20curation%20photography%2C%20aspirational%20lifestyle%20aesthetic&width=800&height=500&seq=art-prev-10&orientation=landscape',
    internal: true,
  },
  {
    slug: 'basetao-shipping-calculator',
    title: 'Basetao Shipping Calculator: Estimate Costs Accurately in 2026',
    excerpt: 'Learn how to use the Basetao shipping calculator, understand weight-based pricing, and estimate your total delivery costs before placing orders.',
    category: 'Shipping',
    image: 'https://readdy.ai/api/search-image?query=Digital%20calculator%20and%20measuring%20tape%20next%20to%20a%20shipping%20label%20on%20a%20clean%20light%20desk%2C%20warm%20natural%20lighting%2C%20cream%20background%2C%20editorial%20logistics%20calculation%20photography%2C%20minimal%20professional%20composition&width=800&height=500&seq=art-prev-11&orientation=landscape',
    internal: true,
  },
  {
    slug: 'basetao-tracking',
    title: 'Basetao Order Tracking Guide: Monitor Your Shipment Step by Step',
    excerpt: 'Complete guide to tracking your Basetao orders — from warehouse departure through customs clearance to final doorstep delivery.',
    category: 'Guide',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20a%20package%20tracking%20map%20interface%20on%20a%20clean%20light%20wooden%20desk%20with%20a%20small%20parcel%20nearby%2C%20warm%20natural%20morning%20light%2C%20cream%20background%2C%20editorial%20delivery%20tracking%20photography%2C%20minimal%20modern%20composition&width=800&height=500&seq=art-prev-12&orientation=landscape',
    internal: true,
  },
];